export const ADD_NEWS_ITEM = "ADD_NEWS_ITEM";
export const DELETE_NEWS_ITEM = "DELETE_NEWS_ITEM";
export const SET_NEWS_ITEM = "SET_NEWS_ITEM";
export const SET_NEWS_ITEMS = "SET_NEWS_ITEMS";
export const SET_EDITING_NEWS_ITEM = "SET_EDITING_NEWS_ITEM";
